import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers"
import ACTIONS from "./ActionTypes"

const initialState = {
    _isCreating: false,
    _isFetching: false,
    _isPatching: false,
    _isDeleting: false,
    _forceFetch: true,
    ids: [],
    entities: {},
    byEntityId: {},
    byEntityType: {},
    fieldsUsedByEntityId: {}
}

const settingsLayoutReducer = (
    state = initialState,
    { payload, type }: any
) => {
    switch (type) {
        case getActionType(ACTIONS.CREATE_LAYOUT).REQUEST: {
            return {
                ...state,
                _isCreating: true,
                _forceFetch: false
            }
        }

        case getActionType(ACTIONS.FETCH_LAYOUTS).REQUEST: {
            const { shouldRequestInBackground } = payload;
            
            return {
                ...state,
                _isFetching: !shouldRequestInBackground,
                _forceFetch: false
            }
        }

        case getActionType(ACTIONS.PATCH_LAYOUT).REQUEST: {
            return {
                ...state,
                _isPatching: true,
                _forceFetch: false
            }
        }

        case getActionType(ACTIONS.DELETE_LAYOUT).REQUEST: {
            return {
                ...state,
                _isDeleting: true,
                _forceFetch: false
            };
        }

        case getActionType(ACTIONS.CREATE_LAYOUT).SUCCESS: {
            const { data } = payload;

            const ids: any = [
                data.id,
                ...state.ids
            ];
            const entities = {
                [data.id]: data,
                ...state.entities
            };
            const byEntityId: any = {
                ...state.byEntityId,
                [data.entity]: [
                    data.id,
                    ...(state.byEntityId?.[data.entity] || []),
                ]
            };
            const byEntityType: any = {
                ...state.byEntityType,
                [data.type]: [
                    data.id,
                    ...(state.byEntityType?.[data.type] || []),
                ]
            };

            return {
                ...state,
                _isCreating: false,
                _forceFetch: true,
                ids,
                entities,
                byEntityId,
                byEntityType
            }
        }

        case getActionType(ACTIONS.FETCH_LAYOUTS).SUCCESS: {
            const { data } = payload;
            const ids: any = data?.map(({id}) => (id));
            const entities: any = convertArrayToObject(data, 'id');

            const byEntityId: any = {};
            const byEntityType: any = {};
            data.forEach((item: any) => {
                if (!byEntityId[item.entity]) byEntityId[item.entity] = [];
                if (!byEntityType[item.type]) byEntityType[item.type] = [];
                byEntityId[item.entity].push(item.id);

                if (item.name == 'candidate'
                || item.name == 'business_unit'
                || item.name == 'vacancy'
                || item.name == 'company'
                || item.name == 'contact') return;
                byEntityType[item.type].push(item.id);
            });

            const fieldsUsedByEntityId = data.reduce(
                (acc, curr) => (
                    acc = {
                        ...acc,
                        // @ts-ignore
                        [curr.entity]: [...(new Set([
                            ...(acc?.[curr.entity] ?? []),
                            ...(curr?.fields ?? [])
                        ]))]
                    }
                ),
                {}
            );
            
            return {
                ...state,
                _isFetching: false,
                _forceFetch: true,
                ids,
                entities,
                byEntityId,
                byEntityType,
                fieldsUsedByEntityId
            }
        }

        case getActionType(ACTIONS.PATCH_LAYOUT).SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                _isPatching: false,
                _forceFetch: true,
                entities: {
                    ...state.entities,
                    [data.id]: data
                }
            }
        }

        case getActionType(ACTIONS.DELETE_LAYOUT).SUCCESS: {
            const { data } = payload;

            const ids = [...state.ids].filter((i: any) => i !== data.id);
            const entities = { ...state.entities };
            delete entities[data.id];
            
            const byEntityId = {
                ...state.byEntityId,
                [data.entity]: [...state.byEntityId?.[data.entity]]?.filter(i => i !== data.id)
            };

            const byEntityType = {
                ...state.byEntityType,
                [data.type]: [...state.byEntityType?.[data.type]]?.filter(i => i !== data.id)
            };
            
            return {
                ...state,
                _isDeleting: false,
                _forceFetch: true,
                ids,
                entities,
                byEntityId,
                byEntityType
            }
        }

        case getActionType(ACTIONS.CREATE_LAYOUT).FAILURE:
        case getActionType(ACTIONS.FETCH_LAYOUTS).FAILURE:
        case getActionType(ACTIONS.PATCH_LAYOUT).FAILURE:
        case getActionType(ACTIONS.DELETE_LAYOUT).FAILURE: {
            return {
                ...state,
                _isCreating: false,
                _isFetching: false,
                _isPatching: false,
                _forceFetch: true
            }
        }

        default:
            return state;
    }
}

export default settingsLayoutReducer;